export const renaissance = {
    contact: {
        number: "8123332280",
        display: "(812) 333-2280"
    },
    propertyId: "renaissance-rentals",
}